export const defaultPreviewLazyLoadConfig = { once: true, margin: "300px" };
